<template>
  <vue-page-wrapper :title="htmlTitle" :bread-crumbs="breadCrumbs">
    <v-card>
      <vue-card-title
        title="Clients Follow Up"
        subtitle="Here you can see the report of clients to be followed up."
        :icon="$getIcon('mdiAccountMultipleOutline')"
      >
        <template slot="actions">
          <v-btn icon @click="filter.show = !filter.show">
            <v-icon small v-text="$getIcon('mdiFilterVariant')"></v-icon>
          </v-btn>
        </template>
      </vue-card-title>
      <v-divider></v-divider>
      <v-slide-y-transition>
        <v-row v-show="filter.show" no-gutters>
          <v-col>
            <filter-generator
              v-model="appliedFilters"
              :align-center="false"
              :filters="filterType"
            ></filter-generator>
          </v-col>
        </v-row>
      </v-slide-y-transition>
      <v-divider v-if="filter.show"></v-divider>
      <v-data-table
        :headers="headers"
        :items="fetchedResults"
        :loading="loading"
        :sort-desc.sync="pagination.descending"
        :sort-by.sync="pagination.sortBy"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.rowsPerPage"
        :footer-props="footerProps"
        :server-items-length="pagination.totalItems"
        :mobile-breakpoint="0"
        must-sort
      >
        <template slot="item" slot-scope="props">
          <tr>
            <td>
              {{ props.item.communication_log.contacted_with.client_name }}
            </td>
            <td class="text-center">
              {{ props.item.communication_log.contacted_with.name }}
            </td>
            <td class="text-center">
              {{ props.item.communication_log.logged_by.full_name }}
            </td>
            <td class="text-center">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-hover>
                    <v-icon
                      v-on="on"
                      size="20"
                      v-text="$getIcon('mdiFlash')"
                      class="mr-1"
                      :color="colorMapper[props.item.priority]"
                    ></v-icon>
                  </v-hover>
                </template>
                <span>{{ props.item.priority }}</span>
              </v-tooltip>
            </td>
            <td class="text-center">
              <div>{{ humanizeDate(props.item.remind_on) }}</div>
              <div class="text--secondary">
                {{ humanizeTime(props.item.remind_on) }}
              </div>
            </td>
            <td>{{ props.item.remarks }}</td>
          </tr>
        </template>
        <template slot="no-data">
          <data-table-no-data :loading="loading"></data-table-no-data>
        </template>
      </v-data-table>
    </v-card>
  </vue-page-wrapper>
</template>

<script>
import DataTableMixin from "@/mixins/newDataTableMixin";
import DataTableNoData from "@/components/common/layout_utils/DataTableNoData";
import FilterGenerator from "@/components/common/layout_utils/FilterGenerator";
export default {
  components: {
    DataTableNoData,
    FilterGenerator
  },
  mixins: [DataTableMixin],
  data() {
    return {
      htmlTitle: "Client Follow Up",
      breadCrumbs: [
        { text: "Reports", disabled: true },
        { text: "Client Follow Up", disabled: true }
      ],
      headers: [
        { text: "Client", sortable: false },
        { text: "Contact Person", sortable: false, align: "center" },
        { text: "CRM User", sortable: false, align: "center" },
        { text: "Priority", align: "center", sortable: false },
        { text: "Date/Time", sortable: false, align: "center" },
        { text: "Remarks", sortable: false }
      ],
      filter: {
        show: false
      },
      appliedFilters: {
        dateFilter: {
          start_date: "",
          end_date: ""
        }
      },
      filterType: [
        {
          component: "vue-date-picker",
          bind: "dateFilter",
          props: { label: "Select Date", default: "All Time" }
        }
      ],
      colorMapper: {
        Critical: "red",
        Important: "orange",
        Normal: "green",
        Low: "blue"
      },
      loading: false
    };
  },
  computed: {
    DataTableFilter() {
      return {
        start_date: this.appliedFilters?.dateFilter?.start_date,
        end_date: this.appliedFilters?.dateFilter?.end_date
      };
    }
  },
  created() {
    this.loadDataTableChange();
  },
  methods: {
    fetchDataTable() {
      let endpoint = "api/v1/crm/report/communication-log-reminder/";
      this.loading = true;
      this.$axios
        .get(endpoint, {
          params: this.fullParams
        })
        .then(response => {
          this.loadDataTable(response.data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    humanizeDate(timeStamp) {
      if (timeStamp) return this.$dayjs(timeStamp).format("DD MMM YYYY");
      return "N/A";
    },
    humanizeTime(timeStamp) {
      if (timeStamp) return this.$dayjs(timeStamp).format("hh:mm A");
      return "N/A";
    }
  }
};
</script>
